import Block from './Block'
import store from '../store'

export default class FullwidthMedia extends Block {
  onEnterCompleted() {
    super.onEnterCompleted()
    this.playing = false

    this.resize()
    this.observer()
  }

  bindMethods() {
    super.bindMethods()

    this.onPlayClick = this.onPlayClick.bind(this)
    this.onVideoClick = this.onVideoClick.bind(this)
  }

  getElems() {
    super.getElems()

    this.video = this.el.querySelector('.b-fullwidth-media__video')
    this.player = this.el.querySelector('.b-fullwidth-media__play')
  }

  events() {
    super.events()

    this.player && this.player.addEventListener('click', this.onPlayClick)
    this.video && this.video.addEventListener('click', this.onVideoClick)
  }

  observer() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(() => {
        if (this.playing) {
          store.menu.unlock()
          this.pauseVideo()
        }
      })
    })

    observer.observe(this.el)
  }

  playVideo() {
    this.video.play()
    this.playing = true
    this.el.classList.add('active')
  }

  pauseVideo() {
    this.video.pause()
    this.playing = false
    this.el.classList.remove('active')
  }

  onVideoClick() {
    this.pauseVideo()
  }

  onPlayClick() {
    if (store.isMobile) this.playVideo()
    else {
      store.menu.lock(true)
      store.smoothScroll.scrollTo(this.top, {
        callback: () => this.playVideo()
      })
    }
  }

  resize() {
    this.top = this.el.getBoundingClientRect().top
  }
}
